
define(
	'MHI.PDPCustomFields.Main'
,   [
	]
,   function (
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var pdp = container.getComponent('PDP');
			
			if(pdp)
			{
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet1', 'string', function(context) {
					return context.model.item.custitem_dhi_bullet_1;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet2', 'string', function(context) {
					return context.model.item.custitem_dhi_bullet_2;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet3', 'string', function(context) {
					return context.model.item.custitem_dhi_bullet_3;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet4', 'string', function(context) {
					return context.model.item.custitem_dhi_bullet_4;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet5', 'string', function(context) {
					return context.model.item.custitem_dhi_bullet_5;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'bullet', 'boolean', function(context) {
					return context.model.item.custitem_dhi_bullet_5 || context.model.item.custitem_dhi_bullet_4 
					|| context.model.item.custitem_dhi_bullet_3 || context.model.item.custitem_dhi_bullet_2 || context.model.item.custitem_dhi_bullet_1;
				});
				/*Assembled*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'assembledLength', 'string', function(context) {
					return context.model.item.custitem_dhi_dimension_length_assembld;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'assembledWidth', 'string', function(context) {
					return context.model.item.custitem_dhi_dimension_width_assembled;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'assembledHeight', 'string', function(context) {
					return context.model.item.custitem_dhi_dimension_height_assembld;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'assembledWeight', 'string', function(context) {
					
					return context.model.item.custitem_dhi_weight_assembled;
				});
				/*Assembled*/
				/*Installation*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'specSheet', 'string', function(context) {
					return context.model.item.custitem_dhi_spec_sheet;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'installationSheet', 'string', function(context) {
					return context.model.item.custitem_dhi_instruction_manua;
				});
				/*Installation*/
				/*Swatches*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'swatchFinish', 'string', function(context) {
					return context.model.item.custitem_dhi_finish_swatch;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'swatchColor1', 'string', function(context) {
					return context.model.item.custitem_dhi_color_swatch_1;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'swatchColor2', 'string', function(context) {
					return context.model.item.custitem_dhi_color_swatch_2;
				});
				/*Swatches*/
				/*Icons*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'icon1', 'string', function(context) {
					return context.model.item.custitem_dhi_icon_1;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'icon2', 'string', function(context) {
					return context.model.item.custitem_dhi_icon_2;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'icon3', 'string', function(context) {
					return context.model.item.custitem_dhi_icon_3;
				});
				/*Icons*/
				/*Certification*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'certification1', 'string', function(context) {
					return context.model.item.custitem_dhi_certicon_1;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'certification2', 'string', function(context) {
					return context.model.item.custitem_dhi_certicon_2;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'certification3', 'string', function(context) {
					return context.model.item.custitem_dhi_certicon_3;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'certification4', 'string', function(context) {
					return context.model.item.custitem_dhi_certicon_4;
				});
				/*Certification*/
				/*Warranty*/
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'warranty1', 'string', function(context) {
					return context.model.item.custitem_dhi_warranty_1;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'warranty2', 'string', function(context) {
					return context.model.item.custitem_dhi_warranty_2;
				});
				pdp.addToViewContextDefinition('ProductDetails.Full.View', 'warrantyType', 'string', function(context) {
					return context.model.item.custitem_dhi_warranty_type;
				});
				/*Warranty*/
			}

		}
	};
});
